import { Button, Grid, Typography } from '@material-ui/core'
import React from 'react'

import { Activity, ParticipantType, ServiceType } from './../../../services/Model/Activity'
import { ActivityOutcome } from './../../../services/Model/Outcome'
import CareerExplorationNonEnrolled from './../CareerExplorationNonEnrolled/CareerExplorationNonEnrolled'

const ParticipantOutcomeFormPicker = (
  onFormSubmit: (outcomes: ActivityOutcome) => void,
  onGoBack: () => void,
  activity?: Activity,
  activityOutcomes? : ActivityOutcome
) => {
  const { participantType, serviceType } = activity || {}

  switch (true) {
    case serviceType === ServiceType.CAREER_EXPLORATION_ESSENTIAL_SKILLS &&
      participantType === ParticipantType.NON_ENROLLED: {
        return <CareerExplorationNonEnrolled outcomes={activityOutcomes || {} as ActivityOutcome} onSubmit={onFormSubmit} />
      }
    default: {
      return (
        <Grid container={true} justify="center">
          <Grid item={true} xs={12}>
            <Typography color="secondary" variant="h6" align="center">
              Form Not Available
            </Typography>
          </Grid>

          <Grid item={true} xs={12} style={{display: 'flex', justifyContent: "center"}}>
            <Button
              variant="contained"
              size="medium"
              onClick={onGoBack}
              data-auto="go back"
            >
                Go Back
            </Button>
          </Grid>
        </Grid>
      )
    }
  }
}

export default ParticipantOutcomeFormPicker
